import { createFileRoute } from '@tanstack/react-router';
import { FinanceRulesScreen } from '../../screens/finance/Rules';

export const Route = createFileRoute('/finance/rules')({
  component: FinanceRulesScreen,
});
